import styled from 'styled-components';
import { CardContainer } from './components/LeadCard/LeadCard.styles';

export const SelectTitle = styled.h1`
  font-weight: 600;
  font-size: 2rem;
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.grey900};
  padding-bottom: ${props => props.theme.global.gutterSpace}px;
`;

export const CardsSection = styled.section`
  ${CardContainer} + ${CardContainer} {
    margin-top: ${props => props.theme.global.gutterSpace}px;
  }
`;
